export default "__VITE_ASSET__Cmc3ZQRX__"